import styled from 'styled-components';
import { Input } from '@leasequery/lq.react-component-library';

const SearchBox = styled(Input)`
  margin: ${(props): string =>
    `${props.theme.spaces.lg} ${props.theme.spaces.md}`};
`;

export { SearchBox };
